import { Package } from '../models/package';

export function normalizePackage(pkg: Partial<Package>): Partial<Package> {
    return {
        ...pkg,
        quantity: Math.max(1, +pkg.quantity),
        weight: Math.max(0.1, +pkg.weight),
        width: Math.max(0.1, +pkg.width),
        height: Math.max(0.1, +pkg.height),
        length: Math.max(0.1, +pkg.length),
        value: +pkg.value,
    };
}
